import client from "./client";
import { toastSuccess, toastError } from "../toastHelper";

export const updateTeamSetting = async (teamId, params) => {
  try {
    await client.patch(`/teams/${teamId}`, { team: params });
    toastSuccess("Setting saved.");
    return true;
  } catch {
    toastError("Something went wrong. Please try again.");
    return false;
  }
};
